// Handicap situation codes (E-DEP nomenclature) and their French labels, shared
// by every view screen so a code never shows raw.

export const HANDICAP_LABELS: Record<string, string> = {
  N: 'Aucun',
  A: 'Auditif',
  M: 'Moteur',
  V: 'Visuel',
  AM: 'Auditif et Moteur',
  AV: 'Auditif et Visuel',
  MV: 'Moteur et Visuel',
  T: 'Tous',
  XX: 'Autre',
};

/** French label for a handicap code; the raw text when unknown; fallback when empty. */
export function handicapLabel(value: string | null | undefined, fallback = '-'): string {
  if (!value) return fallback;
  return HANDICAP_LABELS[value] ?? value;
}
